import {
    ShippingClassFactory,
    ShippingClassMapperParameter,
} from "../models/shipping_class";
import httpMixin from "@/v2/mixins/http.js";
import mapperMixin from "@/v2/mixins/mapper.js";

export default {
    mixins: [httpMixin, mapperMixin],
    computed: {
        shippingClassUrl: {
            get() {
                return window.bo.shippingClassUrl;
            },
        },
    },
    methods: {
        _shippingClassMapper(shippingClass) {
            return {
                id: shippingClass.id,
                name: shippingClass.name,
                remarks: shippingClass.remarks,
            };
        },

        parseShippingClass(shippingClass) {
            return ShippingClassFactory.construct(
                this.createMapperParameter(new ShippingClassMapperParameter()),
                shippingClass
            );
        },

        parseShippingClasses(shippingClasses) {
            let parsedShippingClasses = [];

            shippingClasses.forEach((shippingClassData) => {
                const shippingClass =
                    this.parseShippingClass(shippingClassData);
                parsedShippingClasses.push(shippingClass);
            });

            return parsedShippingClasses;
        },

        getShippingClass(id, payload, success, failure) {
            return this.getData(
                `${this.shippingClassUrl}/${id}`,
                payload,
                (response) => {
                    success(this.parseShippingClass(response.data));
                },
                failure
            );
        },

        getShippingClasses(payload, success, failure) {
            return this.getData(
                this.shippingClassUrl,
                payload,
                (response) => {
                    success(
                        this.parseShippingClasses(response.data.data),
                        response.data.meta
                    );
                },
                failure
            );
        },

        createShippingClass(payload, success, failure) {
            return this.postData(
                this.shippingClassUrl,
                payload,
                (response) => {
                    success(this.parseShippingClass(response.data));
                },
                failure
            );
        },

        updateShippingClass(id, payload, success, failure) {
            return this.putData(
                `${this.shippingClassUrl}/${id}`,
                payload,
                (response) => {
                    success(this.parseShippingClass(response.data));
                },
                failure
            );
        },

        createOrUpdateShippingClass(id = null, payload, success, failure) {
            if (id == null) {
                return this.createShippingClass(payload, success, failure);
            } else {
                return this.updateShippingClass(id, payload, success, failure);
            }
        },

        deleteShippingClass(id, payload, success, failure) {
            return this.deleteData(
                `${this.shippingClassUrl}/${id}`,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        deleteShippingClasses(payload, success, failure) {
            return this.postBulkData(
                this.shippingClassUrl,
                null,
                null,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        refreshShippingClass(id, shippingClasses, success, failure) {
            this.getShippingClass(
                id,
                this.shippingClassUrl,
                null,
                (shippingClass) => {
                    shippingClasses[id] = shippingClass;
                    if (success) success(shippingClass);
                },
                failure
            );
        },
    },
};
